import {
  useEffect,
} from 'react';
import {
  subscribeToAuthSessionLoggedOut,
} from 'utils/authSessionSync';
import {
  clearAppAuthState,
} from 'utils/auth';

function getSessionEndedTargetUrl() {
  return window.location.pathname.startsWith('/support')
    ? '/support'
    : '/';
}

function getSessionEndedUrl() {
  const sessionEndedUrl = new URL('/session-ended', window.location.origin);

  sessionEndedUrl.searchParams.set('targetUrl', getSessionEndedTargetUrl());

  return sessionEndedUrl.toString();
}

export default function AuthSessionSync() {
  useEffect(() => (
    subscribeToAuthSessionLoggedOut(() => {
      clearAppAuthState();
      window.location.replace(getSessionEndedUrl());
    })
  ), []);

  return null;
}
